import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
import { useHeader } from "../config/headerContext";
import Modal from "../components/Modal";

const ComingSoon = ({ setShowOverlay }) => {
    const { setShowHeader } = useHeader();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const privacyEmail = "hello@neongod.io";
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        setShowHeader(false); // Hide Header on mount
        return () => setShowHeader(true); // Show Header on unmount
    }, [setShowHeader]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formId = '7846849'; // Your form ID
            const apiKey = 'amz2aTS_as760UOMv3kR6w'; // Your API key

            const response = await fetch(`https://api.convertkit.com/v3/forms/${formId}/subscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    api_key: apiKey,
                    email: email,
                }),
            });

            if (response.ok) {
                setStatus('success');
            } else {
                setStatus('error');
            }
        } catch (error) {
            setStatus('error');
        }
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Helmet>
                <title>neongod - coming soon</title>
            </Helmet>
            <div data-scroll-section className="container coming-soon__container">
                <div className="coming-soon-bg"></div>
                <header className="coming-soon__header">
                    <img src="/logo-white.svg" alt="Neongod Logo" className="logo" />
                </header>
                <div className="coming-soon__content">
                    <h1 className="heading heading--1 coming-soon__heading">coming soon</h1>
                    <div className="container container--600">
                        <form className="form" onSubmit={handleSubmit}>
                            {status === null && (
                                <>
                                    <label className="form__label coming-soon__form-label">Notify me when the site is launched</label>
                                    <div className="form__input-group">
                                        <input
                                            type="email"
                                            placeholder="Your email address"
                                            className="form__input"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                        <button type="submit" className="button">Notify Me</button>
                                    </div>
                                </>
                            )}
                            {status === 'success' && (
                                <div className="form__feedback">
                                    <p className="form__success">Thank you! We’ll notify you when we launch. :)</p>
                                </div>
                            )}
                            {status === 'error' && (
                                <div className="form__feedback">
                                    <p className="form__error">Something went wrong. Please try again. :(</p>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
                <footer className="coming-soon__footer">
                    <p>All rights reserved {currentYear} © neongod LLC.</p>
                    <a href="#!" className="link" onClick={openModal}>Privacy Policy</a>
                </footer>
            </div>

            <Modal isOpen={isModalOpen} onClose={closeModal} title="Privacy Policy">
                <p>We value your privacy and are committed to protecting your personal information. This privacy policy explains how we collect, use, and share information about you when you use our services.</p>
                <p><strong>Information Collection:</strong> We collect your email address when you subscribe to our mailing list. This information is used solely for the purpose of sending you updates and promotional materials related to our services. We use kit.com to manage our email subscriptions.</p>
                <p><strong>Information Use:</strong> Your email address will be used to send you newsletters, updates, and other promotional content. We do not share your email address with third parties without your consent, except as required by law.</p>
                <p><strong>Data Security:</strong> We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.</p>
                <p><strong>Your Rights:</strong> You have the right to unsubscribe from our mailing list at any time. You can do this by clicking the unsubscribe link in any of our emails or by contacting us directly.</p>
                <p><strong>Contact Us:</strong> If you have any questions or concerns about our privacy policy, please contact us at <a href={`mailto:${privacyEmail}`} className="link">{privacyEmail}</a>.</p>
            </Modal>
        </>
    );
}

export default ComingSoon;